/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {MDBBreadcrumb, MDBBreadcrumbItem} from 'mdbreact'
import {Link, Redirect} from 'react-router-dom'
import BASE_MANAGE from '../BaseComponent/BASEMANAGE'

class AddVersion extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: '',
      redirect: false
    }
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  componentDidMount() {}

  addVersion() {
    var type = document.getElementById('type').value
    var version = this.convertDigit(document.getElementById('version').value)
    var code = this.convertDigit(document.getElementById('code').value)
    var stable = document.getElementById('stable').value
    var force = document.getElementById('force').value
    var fileVal = document.getElementById('file').value
    var fileElement = document.getElementById('file')

    var formData = new FormData()
    var typeError = false
    var fileError = false
    var versionError = false
    var codeError = false
    var formError = false
    if (type == '') {
      typeError = true
      formError = true
      message.error('نوع ورژن را مشخص کنید')
    } else {
      if (!typeError) {
        this.setState({error: ''})
      }
    }

    if (fileVal == '') {
      fileError = true
      formError = true
      message.error('فایل را مشخص کنید')
    } else if (fileVal.substring(fileVal.length - 4, fileVal.length) !== '.apk') {
      fileError = true
      formError = true
      message.error('فرمت فایل باید apk. باشد')
    } else {
      if (!fileError) {
        this.setState({error: ''})
      }
    }

    if (version == '') {
      versionError = true
      formError = true
      message.error('شماره ورژن را مشخص کنید')
    } else if (!version.match(/(?!\.)(\d+(\.\d+)+)(?![\d\.])$/g)) {
      versionError = true
      formError = true
      message.error('شماره ورژن را با الگوی 1.1.1 ثبت کنید.')
    } else if (version < '1') {
      versionError = true
      formError = true
      message.error('شماره ورژن باید حداقل یک باشد')
    } else {
      if (!versionError) {
        this.setState({error: ''})
      }
    }

    if (code == '') {
      codeError = true
      formError = true
      message.error('شماره کد را مشخص کنید')
    } else if (!code.match(/[1-9\d]/g)) {
      codeError = true
      formError = true
      message.error('شماره کد باید عدد باشد')
    } else if (code < '1') {
      codeError = true
      formError = true
      message.error('شماره کد باید حداقل یک باشد')
    } else {
      if (!codeError) {
        this.setState({error: ''})
      }
    }

    if (!formError) {
      formData.append('type', type)
      formData.append('version', version)
      formData.append('code', code)
      formData.append('force', force == 'true' ? force : !force)
      formData.append('stable', stable == 'true' ? stable : !stable)
      formData.append('file', fileElement.files[0])

      http.post(`${BASE_MANAGE.BASE_MANAGE_SYSTEM_ADD_APPVERSION}`, formData, {}).then((response) => {
        if (response.data.error == null) {
          message.success('ورژن جدید اضافه شد')
          setInterval(() => {
            window.location.assign('/version')
          }, 2000)
        } else {
          // message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
    }
  }

  renderRedirect = () => {
    if (this.state.redirect) {
      return <Redirect to="/version" />
    }
  }

  submit(e) {
    e.preventDefault()
  }

  render() {
    return (
      <div className="rtl">
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>
              <Link to={'/version'}>نسخه های اپلیکیشن</Link>
            </li>
            <li>ثبت نسخه جدید</li>
          </ul>
          <form enctype="multipart/form-data" className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>ثبت ورژن</p>
            </div>
            <div className="formComponent">
              <label>
                نوع ورژن<span className="requireFiled">*</span>
              </label>
              <select className="form-control" id="type" name="type">
                <option value="">------</option>
                <option value="customer">مشتری</option>
                <option value="driver">رساننده</option>
              </select>

              <label>
                کد <span className="requireFiled">*</span>
              </label>
              <input type="number" min="1" id="code" name="code" className="form-control" />

              <label>
                شماره ورژن <span className="requireFiled">*</span>
              </label>
              <input type="text" id="version" name="version" className="form-control" />

              <label>
                وضعیت ثبات <span className="requireFiled">*</span>
              </label>
              <select className="form-control" id="stable" name="stable">
                <option value={true}>با ثبات</option>
                <option value={false}>بی ثبات</option>
              </select>

              <label>
                وضعیت دانلود <span className="requireFiled">*</span>
              </label>
              <select className="form-control" id="force" name="force">
                <option value={true}>اجباری</option>
                <option value={false}>اختیاری</option>
              </select>

              <label>
                فایل <span className="requireFiled">*</span>
              </label>
              <input type="file" min="1" id="file" name="file" className="form-control" />

              <button className="btn btn-info btn-block" onClick={this.addVersion.bind(this)}>
                ثبت ورژن جدید
              </button>
              {this.renderRedirect()}
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default AddVersion
